module.exports = __webpack_public_path__ + "img/me-header-background-en.99818c1c.png";